import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	approveReason: null,
	error: "",
	loading: false,
};

// ADD_approveReason
export const addApproveReason = createAsyncThunk(
	"approveReason/addApproveReason",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `approveReason`,
				data: {
					...values,
				},
			});
			toast.success("Approve Reason added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Approve Reason try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_approveReason
export const deleteApproveReason = createAsyncThunk(
	"approveReason/deleteApproveReason ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `approveReason/${id}`,
			});

			toast.success("Approve Reason deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Approve Reason try again");
			console.log(error.message);
		}
	}
);


// approveReason
export const getAllApproveReason = createAsyncThunk(
	"approveReason/getAllApproveReason",
	async () => {
		try {
			const { data } = await axios.get(`approveReason`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateApproveReason = createAsyncThunk(
	"approveReason/updateApproveReason",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `approveReason/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Approve Reason updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Approve Reason try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const approveReasonSlice = createSlice({
	name: "approveReason",
	initialState,
	reducers: {
		clearApproveReason: (state) => {
			state.approveReason = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllApproveReason ======

		builder.addCase(getAllApproveReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllApproveReason.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllApproveReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addApproveReason  ======

		builder.addCase(addApproveReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addApproveReason.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addApproveReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for updateApproveReason ======

		builder.addCase(updateApproveReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateApproveReason.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateApproveReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteApproveReason  ======

		builder.addCase(deleteApproveReason.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteApproveReason.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteApproveReason.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default approveReasonSlice.reducer;
export const { clearApproveReason } = approveReasonSlice.actions;
